// src/components/Auth/Login.js
import { signInWithEmailAndPassword } from "firebase/auth";
import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell, { AuthAlert } from "../../components/AuthShell";
import { SUCCESS_REDIRECT_URL } from "../../../constants";
import { auth } from "../../../firebase";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      setError("");
      await signInWithEmailAndPassword(
        auth,
        emailRef.current.value,
        passwordRef.current.value
      );
      navigate(SUCCESS_REDIRECT_URL);
    } catch (error) {
      setError(`Failed to log in: ${error.message}`);
      console.error("LOGIN_FAILED", error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <AuthShell
      eyebrow="Welcome back"
      title="Log in"
      subtitle="Access your dashboard and manage every page from one place."
      footer={
        <div className="space-y-3">
          <p>
            Need an account?{" "}
            <Link to="/signup" className="font-semibold text-[#FF3A20] hover:text-[#e8321c]">
              Sign up
            </Link>
          </p>
          <Link to="/password-reset" className="font-semibold text-slate-700 hover:text-slate-950">
            Forgot password?
          </Link>
        </div>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        {error && <AuthAlert>{error}</AuthAlert>}

        <div className="field-group">
          <label htmlFor="email" className="field-label">
            Email
          </label>
          <input
            type="email"
            id="email"
            ref={emailRef}
            required
            autoComplete="email"
            className="field-input"
            placeholder="you@example.com"
          />
        </div>

        <div className="field-group">
          <label htmlFor="password" className="field-label">
            Password
          </label>
          <input
            type="password"
            id="password"
            ref={passwordRef}
            required
            autoComplete="current-password"
            className="field-input"
            placeholder="Enter your password"
          />
        </div>

        <button type="submit" className="primary-button w-full" disabled={isSubmitting}>
          {isSubmitting ? "Logging in..." : "Log in"}
        </button>
      </form>
    </AuthShell>
  );
}
